import { render, staticRenderFns } from "./BaseFieldSort.vue?vue&type=template&id=5374c26b&"
import script from "./BaseFieldSort.vue?vue&type=script&lang=js&"
export * from "./BaseFieldSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports